import React, { FC } from "react";
import Section from "../../components/section";
import { PageHero } from "../../components/page-hero";
import Layout from "../../components/layout/layout";
import tech_1 from '../../images/monitoringScreens/teck_1.jpg';
import tech_2 from '../../images/monitoringScreens/teck_2.jpg';
import tech_3 from '../../images/monitoringScreens/teck_3.jpg';
import tech_4 from '../../images/monitoringScreens/teck_4.jpg';
import tech_5 from '../../images/monitoringScreens/teck_5.jpg';
import './styles.scss';

const TecknologyMonitoring: FC = () => (
  <div className="content-wrapper">
    <PageHero
      title="Technology monitoring"
      subtitle="Monitor changes to the tech stack or 3rd party scripts used on the web page."
    />
    <Layout>
      <Section>
        <div className="col-lg-12 technology-monitoring">
          <iframe src="https://www.youtube.com/embed/kRlCnhEeXC8?rel=0"
            frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>

          <h2>Technology monitor - Walkthrough</h2>
          <br />
          <div className="img-block">
            <img src={tech_1} alt="Select technology monitoring tool" />
          </div>
          <p className="mb">
            With our technology monitor, you can check any page for tech
            changes and get alerts when third party scripts are added or
            removed from that page. This type of monitor is ideal to check if a
            tracking script was removed by mistake or to monitor a prospects
            website so you can be alerted if they make any change of vendor.
          </p>

          <div className="img-block">
            <img src={tech_2} alt="Preview desired URL" />
          </div>
          <p className="mb">
            To get started enter the url you want to check and click preview.
          </p>

          <div className="img-block">
            <img src={tech_3} alt="Hexowatch will then detect the current tech stack used on the page" />
          </div>
          <p className="mb">
            Hexowatch will then detect the current tech stack used on the
            page. You can then choose to monitor for any tech changes, or
            specify a specific technology or script to look for. For example, you
            can use this to detect if Google analytics was removed by mistake.
          </p>

          <div className="img-block">
            <img src={tech_4} alt="You can choose the frequency of the checks" />
          </div>
          <p className="mb">
            Next, you can choose the frequency of the checks, your preferred
            notification channels, as well set custom start and end dates.
          </p>

          <div className="img-block">
            <img src={tech_5} alt="Click start monitoring to get started" />
          </div>
          <p className="mb">
            Then click start monitoring to get started. Hexowatch will keep an
            eye on the page and will notify you when any technology changes
            are detected.
          </p>
        </div>
      </Section>
    </Layout>
  </div>
);

export default TecknologyMonitoring;
